
<template >
    <div class="wrapper">
      <div class="content text-center">
        
        <h1 class="text-center mt-5"><i class="fas fa-user fa-3x" style="color:#003c71"></i></h1>
        <h1>{{userId}}</h1>
      </div>
      
      <div class="foot">
          <p>&copy; 2024 Latino Seguros.</p>
      </div>
   
    </div>
  </template>
  
  <script>
  import NavbarSas from './navbarSas.vue';
  import Footer from './Tools/footer.vue'
  export default {
  components: {NavbarSas, Footer},
      data() {
        return {
          userId: localStorage.getItem("userId")
        }
      },
      methods: {}
          
  }
  
  </script>
  
  
  <style scoped>
  .content {
    height: 500px;
  }
  .foot {
      /* position: sticky; */
      background-color: #003c71;
      height: 60px;
      margin-top:13%
  }
  .foot p {
      padding: 20px;
      color: #ffffff;
      text-align: center;
  }
  .btn-see{
      border-radius: 10px;
      background-image: linear-gradient(to right, #085da8, #003c71); /* Color de fondo verde */
      border: #003c71;
  }
    /* modal alert */
    .btn-modal{
      background-color: #3085d6;
      color: #ffffff;
      font-size: medium;
  }
  .card-header-error {
      background-color: rgb(255, 255, 255);
      height: 8rem;
  }
  .iframePdf {
      height: 350px;
  }
  .card-header {
      background-color: rgb(33, 46, 102);
  }
  small{
      font-size: small;
  }
  .titulo {
      color: #000000;
      margin-bottom: 0%;
      margin-top: 2%;
  }
  .file-select {
    position: relative;
    display: inline-block;
    cursor: pointer !important;
  
  }
  
  .file-select::before {
    background-color: #ffffff;
    color: rgba(4, 12, 34, 0.664);
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    /* border-radius: 3px; */
    content: 'Seleccionar';
    position: absolute !important;
    left:5% !important;
    top: 20% !important;
    cursor: pointer !important;
  }
  
  .file-select input[type="file"] {
    opacity: 0 !important;
    width: 200px !important;
    height: 32px !important;
    display: inline-block !important;
    cursor: pointer !important;
  }
  
  #src-file1::before {
    content: 'Selecciona tu archivo';
    cursor: pointer !important;
  }
  #yourBtn {
    font-family: calibri;
    width: 170px;
    /* text-align: center; */
    margin-left:  20px;
    background-color: rgb(255, 255, 255);
    cursor: pointer;
  }
  .navbar{
      background-color: white;
      height: 90px;
  }
  .imagen {
      height: 50px;
  }
  .target{
      box-shadow: 5px 5px 5px rgb(218, 216, 216);
      border-radius: 10px;
      height: 28rem;
      width: 25rem;
  }
  .icono {
      color: #000000;
  }
  .borde{
      border-top-left-radius: 0.5em 1em; 
      border-bottom-left-radius: 0.5em 1em;
  }
  .coltxt{
      padding: 10px;
      line-height: 0; 
  }
  
  </styles>